module.exports = __webpack_public_path__ + "img/logo4.d1152d9e.jpg";